import { z } from "@/zod";

export const departmentId = z.string().length(26);
